import { Flex } from "antd";
import styled from "styled-components";
import { radius } from "@libertify/ui";

export const SWATCH_SIZE = 18;

export const StyledColorPickerWrapper = styled(Flex)<{ $showBorders: boolean }>`
  .ant-color-picker-trigger {
    border: ${({ $showBorders, theme }) =>
      $showBorders ? "0px" : `1px solid ${theme.colorBorder}`};
    box-shadow: none;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
  }
  .ant-color-picker-palette {
    min-height: unset !important;
    height: 90px;
  }

  .ant-color-picker-color-block,
  .ant-color-picker-clear {
    width: 22px !important;
    height: 22px !important;
  }

  .ant-popover-inner {
    .ant-color-picker-input-container {
      justify-content: center;
      .ant-color-picker-input {
        flex: 100px 0 0;
      }
    }
    .ant-color-picker-clear {
      border-radius: ${radius.circle} !important;
      cursor: pointer !important;
    }
  }

  .ant-color-picker-operation {
    position: absolute;
    right: 0;

    &:has(.ant-segmented) {
      position: static;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      margin-bottom: 8px;

      .ant-color-picker-clear {
        position: absolute;
        top: 0;
        right: 0;
      }
    }
  }

  .ant-color-picker-slider-group {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }

  .ant-color-picker-presets-color:hover::before {
    display: none !important;
  }

  .ant-color-picker-presets {
    /* hide the collapsible when empty label (from brandkit presets for instance) */
    .ant-collapse-header:has(.ant-color-picker-presets-label:empty) {
      display: none !important;
    }

    .ant-color-picker-presets-color {
      width: ${SWATCH_SIZE}px !important;
      height: ${SWATCH_SIZE}px !important;

      &::before {
        width: ${SWATCH_SIZE + 4}px !important;
        height: ${SWATCH_SIZE + 4}px !important;
      }
      &::after {
        /* checkmark */
        height: 10px !important;
      }
      .ant-color-picker-color-block-inner {
        border: 1px solid ${({ theme }) => theme.colorGrey} !important;
      }
    }
  }
  .ant-slider-handle::after {
    border-color: ${({ theme }) => theme.colorPrimary} !important;
  }
  .ant-color-picker-handler {
    border-color: ${({ theme }) => theme.colorPrimary} !important;
  }
`;
